{
  "dss": {
    "button": {
      "back": "Quay lại",
      "cancel": "Hủy",
      "close": "Đóng",
      "confirmDelete": "Có, xóa",
      "continue": "Tiếp tục",
      "logout": "Đăng xuất",
      "passwordReset": "Đặt lại mật khẩu",
      "save": "Lưu",
      "verify": "Xác minh"
    },
    "error": {
      "403": "Bạn không có quyền truy cập trang này.",
      "404": "Trang này không tồn tại.",
      "generic": "Đã xảy ra lỗi. Vui lòng thử lại sau.",
      "throttling": "Quá nhiều lần thử. Thao tác này tạm thời bị chặn.",
      "title": "Lỗi",
      "title403": "Từ chối truy cập",
      "title404": "Không tìm thấy"
    },
    "footer": {
      "imprint": "Imprint",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Chính sách quyền riêng tư",
      "terms": "Điều khoản và Điều kiện"
    },
    "label": {
      "CRMAccountNumber": "Số tài khoản CRM",
      "contact": "Liên hệ",
      "email": "Email",
      "faq": "Câu hỏi thường gặp",
      "female": "Bà/Cô",
      "firstname": "Tên",
      "help": "Trợ giúp",
      "language": "Ngôn ngữ",
      "lastname": "Họ",
      "male": "Ông",
      "needHelp": "Cần trợ giúp?",
      "newPassword": "Mật khẩu mới",
      "newPassword2": "Xác nhận mật khẩu mới",
      "oldPassword": "Mật khẩu hiện tại",
      "organization": "Tổ chức",
      "password": "Mật khẩu",
      "required": "bắt buộc",
      "salutation": "Xưng hô",
      "select": "Vui lòng chọn"
    },
    "lang": {
      "de": "Tiếng Đức"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Xác nhận đăng ký",
        "wait": "Vui lòng đợi để hoàn tất xác nhận tài khoản."
      },
      "otp": {
        "btnResend": "Gửi lại email mã xác minh",
        "msg": {
          "invalidOTP": "Mật khẩu dùng một lần đã nhập không hợp lệ.",
          "resendFail": "Gửi lại mã không thành công. Vui lòng thử lại sau."
        },
        "spamDetail": "Kiểm tra hộp thư đến và thư rác cho email từ STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Bạn không nhận được email?",
        "subtitle": "Để tiếp tục, bạn cần xác minh địa chỉ email của mình.",
        "title": "Xác minh tài khoản người dùng của bạn",
        "txtVerifyMail": "Vui lòng nhập mã xác minh mới mà chúng tôi đã gửi tới địa chỉ email {email} của bạn"
      },
      "personal": {
        "msg": {
          "noChange": "Không có gì để cập nhật.",
          "updateError": "Không thể cập nhật dữ liệu cá nhân.",
          "updated": "Dữ liệu cá nhân đã được cập nhật.",
          "userLoadErr": "Lỗi khi tải dữ liệu người dùng. Vui lòng thử lại sau."
        },
        "secOrganization": "Tổ chức",
        "secPersonal": "Cá nhân",
        "secSettings": "Cài đặt ưu tiên",
        "title": "Thông tin cá nhân"
      },
      "postPwSet": {
        "info": "Bây giờ bạn có thể sử dụng mật khẩu mới.",
        "link_name": "Tiếp tục đến Self-Service",
        "link_url": "/user/ui/",
        "title": "Mật khẩu của bạn đã được thay đổi"
      },
      "resetPW": {
        "title": "Đặt lại mật khẩu của bạn"
      },
      "security": {
        "2fa": {
          "availableMethods": "Các phương thức 2FA khả dụng:",
          "info": "Xác thực hai yếu tố (2FA) là tính năng bảo mật bổ sung thêm một lớp bảo vệ cho tài khoản của bạn. Yêu cầu bạn sử dụng hai phương thức để đăng nhập thay vì chỉ tên người dùng và mật khẩu.",
          "method": {
            "email": "Email",
            "emailDesc": "Nhận mã dùng một lần qua email để hoàn tất yêu cầu xác thực.",
            "oath": {
              "add": {
                "button": "Đăng ký ứng dụng Authenticator"
              }
            }
          }
        },
        "authenticator": "Ứng dụng Authenticator",
        "infoFederatedAccount": "Tài khoản này được quản lý bởi nhà cung cấp danh tính của tổ chức bạn, vì vậy không thể thay đổi mật khẩu tại đây. Để thay đổi mật khẩu, hãy đăng nhập qua trang đăng nhập của tổ chức bạn hoặc liên hệ với quản trị viên CNTT của bạn.",
        "lastUse": "Lần sử dụng gần nhất: {0}.",
        "msg": {
          "invalidPassword": "Mật khẩu hiện tại không hợp lệ.",
          "passwordAlreadyUsed": "Không thể sử dụng lại 5 mật khẩu gần nhất.",
          "pwUpdateError": "Đã xảy ra lỗi khi cố gắng đổi mật khẩu.",
          "pwUpdated": "Mật khẩu đã được thay đổi."
        },
        "noDevice": "Chưa cấu hình",
        "oathAdd": {
          "appInfo": "Để đơn giản hóa việc đăng nhập vào STIHL, bạn có thể sử dụng các ứng dụng Authenticator như {0}, {1}, {2}... để tạo mật khẩu dùng một lần được sử dụng như yếu tố thứ hai trong quá trình đăng nhập.<br/>Nếu bạn làm mất hoặc quên thiết bị di động, bạn luôn có thể sử dụng mã 2FA được gửi qua email.<br/><br/>Vui lòng làm theo hướng dẫn bên dưới để thiết lập thiết bị xác thực của bạn.",
          "badCode": "Mã không hợp lệ, vui lòng thử lại.",
          "error": "Đã xảy ra lỗi khi đăng ký thiết bị xác thực.",
          "headScan": "1. Quét mã QR bằng ứng dụng Authenticator",
          "headVerify": "2. Xác minh mã",
          "infoKey": "khóa cài đặt",
          "infoKeyTitle": "Bí mật xác thực hai yếu tố của bạn",
          "infoScanBottom": "Không thể quét? Bạn có thể dùng {0} để cấu hình thủ công ứng dụng Authenticator.",
          "infoVerify": "Nhập mã được tạo bởi ứng dụng Authenticator của bạn.",
          "success": "Thiết bị xác thực của bạn đã được đăng ký. Giờ đây bạn có thể dùng nó để đăng nhập.",
          "title": "Đăng ký thiết bị xác thực hai yếu tố của bạn"
        },
        "oathDelete": {
          "error": "Đã xảy ra lỗi khi xóa thiết bị xác thực.",
          "success": "Thiết bị xác thực đã được xóa."
        },
        "passkeys": {
          "about": {
            "info1": "Passkey là cặp khóa mật mã (khóa công khai và khóa riêng) được lưu bởi một thiết bị xác thực do bạn kiểm soát. Thiết bị xác thực có thể chứng minh người dùng đang hiện diện và được phép dùng passkey. Việc ủy quyền được chứng minh bằng PIN, mã, sinh trắc học hoặc mật khẩu thiết bị, tùy theo khả năng và cấu hình của thiết bị xác thực. Thiết bị xác thực có nhiều dạng như iPhone hoặc thiết bị Android, Windows Hello, khóa bảo mật phần cứng FIDO2 hoặc trình quản lý mật khẩu.",
            "info2": "Khi bạn đăng nhập vào STIHL bằng passkey, thiết bị xác thực của bạn dùng mật mã khóa công khai để chứng minh danh tính của bạn với STIHL mà không bao giờ gửi passkey. Passkey gắn với tên miền trang web như stihl-sso.com và yêu cầu kết nối an toàn, nghĩa là trình duyệt sẽ từ chối xác thực trên trang web lừa đảo tương tự. Các đặc tính này khiến passkey có khả năng chống lừa đảo rất cao và khó bị tấn công hơn nhiều so với SMS hoặc TOTP 2FA.",
            "info3": "Các dịch vụ passkey hỗ trợ đám mây cho phép đồng bộ passkey giữa các thiết bị (ví dụ thiết bị Apple, Android hoặc trình quản lý mật khẩu) để có thể sử dụng ở nhiều nơi hơn và ít bị mất hơn. Khi bạn thiết lập một passkey được đồng bộ trên một thiết bị, passkey đó có sẵn để sử dụng trên nhiều thiết bị dùng cùng dịch vụ. Ví dụ, nếu bạn đăng ký passkey với tài khoản iCloud bằng Touch ID trên MacBook, bạn có thể dùng passkey đó bằng khuôn mặt, vân tay, PIN hoặc mật khẩu thiết bị trên nhiều thiết bị liên kết với cùng tài khoản iCloud.",
            "title": "Giới thiệu về Passkeys"
          },
          "add": {
            "button": "Thêm Passkey mới",
            "error": "Đã xảy ra lỗi khi thêm passkey mới.",
            "success": "Đã thêm một passkey mới."
          },
          "delete": {
            "button": "Xóa Passkey",
            "error": "Đã xảy ra lỗi khi xóa passkey này.",
            "success": "Passkey đã được xóa."
          },
          "edit": {
            "error": "Đã xảy ra lỗi khi lưu tên passkey.",
            "name": "Tên Passkey",
            "success": "Tên passkey đã được cập nhật.",
            "title": "Đặt tên Passkey của bạn để phân biệt với các passkey khác"
          },
          "info": "Passkey là một giải pháp thay thế đơn giản và an toàn cho mật khẩu, xác thực danh tính của bạn bằng chạm, nhận diện khuôn mặt, mật khẩu thiết bị hoặc PIN.",
          "none": "Chưa cấu hình Passkey nào.",
          "reallyDelete": "Bạn có chắc muốn xóa Passkey không?",
          "registeredPasskeys": "Passkey đã đăng ký của bạn:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Bạn có chắc muốn xóa thiết bị xác thực không?",
        "secMFA": "Xác thực hai yếu tố",
        "secPwdChange": "Đổi mật khẩu",
        "title": "Bảo mật"
      },
      "setPW": {
        "acceptTC": "Vui lòng xác nhận {terms} của chúng tôi và đọc {privacy} của chúng tôi.",
        "killSSO": "Hủy hiệu lực tất cả các phiên đang hoạt động",
        "msg": {
          "tokenExpired": "Liên kết hoặc mã mật khẩu đã hết hạn. Vui lòng theo liên kết để đặt lại mật khẩu của bạn: {link}."
        },
        "privacy": "Chính sách quyền riêng tư dữ liệu",
        "terms": "Điều khoản và Điều kiện",
        "title": "Nhập mật khẩu mới"
      }
    },
    "validations": {
      "hasDigit": "Phải chứa chữ số",
      "hasLowercase": "Phải chứa chữ thường",
      "hasSpecial": "Phải chứa ký tự đặc biệt: {chars}",
      "hasUppercase": "Phải chứa chữ hoa",
      "invalidCharacters": "Chứa ký tự không hợp lệ",
      "maxLength": "Tối đa {max} ký tự",
      "minLength": "Tối thiểu {min} ký tự",
      "notSameAsEmail": "Quá giống địa chỉ email",
      "onlyValidCharactersAllowed": "Chỉ cho phép chữ cái, số và khoảng trắng.",
      "required": "Trường bắt buộc",
      "sameAsPassword": "Mật khẩu không khớp",
      "tcAccepted": "Vui lòng xác nhận điều khoản và điều kiện của chúng tôi.",
      "validEmail": "Địa chỉ email không hợp lệ.",
      "validOTP": "Vui lòng nhập mã xác minh."
    }
  }
}
